import React, { useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './InnerPage.css';

export default function AccountDeletionPage() {
      const { t } = useLanguage();

      useEffect(() => {
            window.scrollTo(0, 0);
      }, []);

      return (
            <div className="inner-page">
                  <Navbar />

                  <section className="inner-page__hero">
                        <div className="inner-page__hero-inner">
                              <div className="inner-page__tag">{t('deletion.tag')}</div>
                              <h1 className="inner-page__title">{t('deletion.title')}</h1>
                              <p className="inner-page__subtitle">
                                    {t('deletion.subtitle')}
                              </p>
                        </div>
                  </section>

                  <div className="inner-page__content">

                        <div className="content-card">
                              <h2 className="content-card__title">{t('deletion.stepsTitle')}</h2>
                              <p>{t('deletion.stepsIntro')}</p>
                              <ol className="content-card__list">
                                    <li>{t('deletion.step1')}</li>
                                    <li>{t('deletion.step2')}</li>
                                    <li>{t('deletion.step3')}</li>
                                    <li>{t('deletion.step4')}</li>
                              </ol>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('deletion.deletedTitle')}</h2>
                              <p>{t('deletion.deletedIntro')}</p>
                              <ul className="content-card__list">
                                    <li>{t('deletion.deleted1')}</li>
                                    <li>{t('deletion.deleted2')}</li>
                                    <li>{t('deletion.deleted3')}</li>
                                    <li>{t('deletion.deleted4')}</li>
                                    <li>{t('deletion.deleted5')}</li>
                                    <li>{t('deletion.deleted6')}</li>
                              </ul>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('deletion.retainedTitle')}</h2>
                              <p>{t('deletion.retainedIntro')}</p>
                              <ul className="content-card__list">
                                    <li>{t('deletion.retained1')}</li>
                                    <li>{t('deletion.retained2')}</li>
                                    <li>{t('deletion.retained3')}</li>
                              </ul>
                              <p>{t('deletion.retainedNote')}</p>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('deletion.timelineTitle')}</h2>
                              <p>{t('deletion.timelineText')}</p>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('deletion.contactTitle')}</h2>
                              <p>{t('deletion.contactText')}</p>
                              <a href="mailto:admin@agrollama.com?subject=Account%20deletion%20request" className="contact-highlight" id="deletion-contact-email">
                                    {t('deletion.contactEmail')}
                              </a>
                        </div>

                  </div>

                  <Footer />
            </div>
      );
}
